import {
  SlButton,
  SlDrawer,
  SlIcon,
  SlTooltip,
} from "@shoelace-style/shoelace/dist/react";
import React, { useEffect, useState, useRef } from "react";
import API from "../../services/api";
import AddAdPartner from "./AddAdPartner";
import { formatDateDDMMYYY } from "../../utils/dateFormat";
import NetworkAdStats from "./NetworkAdStats";
import Datepicker from "react-tailwindcss-datepicker";
import ScrollContainer from "react-indiana-drag-scroll";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import AdPartnerCharts from "./AdPartnerCharts";
import { toLakhs, newspaperLangs, adPositions } from "../../utils/constants";
import { Toast } from "../../shared/Toast";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import Loader from "../../shared/Loader";
import { CSVLink } from 'react-csv';
import NetworkStatsTable from "./NetworkStatsTable";
import ExchangeRates from "./ExchangeRates";



/*****************************/
function AdPartners() {
  const [adPartners, setAdPartners] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uploading ,setIsUploading]=useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const [adPartnerData, setAdPartnerData] = useState(null);
  const [lang_id, setLangId] = useState({ value: 1, label: "Telugu" });
  const [position, setPosition] = useState({ value: -1, label: "All" });
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const [dateRange, setDateRange] = useState({
    startDate: yesterday,
    endDate: yesterday,
  });
  const [flag, setFlag] = useState("add");
  const [data, setData] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [editStatsData, setEditStatsData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState({
    id: null,
    status: null,
  });
  const [expandedRow, setExpandedRow] = useState(null);
  const [positionData, setPositionData] = useState({});
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null); // Added ref for file input
  const [viewMode, setViewMode] = useState("network");
  
  const positionOptions = adPositions.map((pos) => ({
    value: pos,
    label: pos === -1 ? "All" : pos.toString(),
  }));

  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }

  const loadAdPartners = async () => {
    setIsLoading(true);
    try {
      const res = await API({
        url: "/adpartners/getadpartners",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setAdPartners(res.data);
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Failed to load ad partners.");
    } finally {
      setIsLoading(false);
    }
  };

  const loadData = async () => {
    setIsDataLoading(true);
    try {
      const res = await API({
        url: "/adpartners/data",
        method: "POST",
        responseType: "json",
        data: {
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
          lang_id: lang_id.value,
          position: position.value,
        },
      });
      if (res.code === 200) {
        setData(res.data);
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Failed to load stats data.");
    } finally {
      setIsDataLoading(false);
    }
  };

  const loadPositionData = async (ad_partner_id) => {
    try {
      const res = await API({
        url: `/adpartners/data/${ad_partner_id}`,
        method: "POST",
        responseType: "json",
        data: {
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
          lang_id: lang_id.value,
          ad_partner_id: ad_partner_id,
        },
      });
      if (res.code === 200) {
        setPositionData(res.data);
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Failed to load position data.");
    }
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (
      selectedFile &&
      (selectedFile.type === "text/csv")
    ) {
      setFile(selectedFile);
    } else {
      Toast("error", "Please select a valid CSV or Excel file.");
    }
  };

  const handleFileUpload = async () => {
    if (!file) {
      Toast("error", "No file selected.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    setIsUploading(true);
    try {
      const res = await API({
        url: "/adpartners/file",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.code === 200) {
        Toast("success", res.message);
        loadAdPartners();
        loadData();
        setFile(null);
        fileInputRef.current.value = null; // Clear the file input
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Failed to upload file.");
    }
    setIsUploading(false);
  };

  const handleToggleRow = async (ad_partner_id) => {
    if (expandedRow === ad_partner_id) {
      setExpandedRow(null); // Collapse if already expanded
    } else {
      setExpandedRow(ad_partner_id); // Expand new row, closing others
      await loadPositionData(ad_partner_id); // Fetch data when row is clicked
    }
  };

  const handleStatus = async () => {
    const { id, status } = selectedStatus;
    try {
      const res = await API({
        url: "/adpartners/status",
        method: "POST",
        responseType: "json",
        data: {
          id,
          status: status === 1 ? 0 : 1,
        },
      });
      if (res.code === 200) {
        Toast("success", "Status Updated Successfully");
        loadAdPartners();
        setShowModal(false);
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
      Toast("error", "Failed to update status.");
    }
  };

  useEffect(() => {
    loadData();
    // Reset expanded row and clear positionData on filter change
    setExpandedRow(null);
    setPositionData({});
  }, [dateRange, lang_id, position]);

  useEffect(() => {
    loadAdPartners();
    // Ensure no row is expanded on component mount
    setExpandedRow(null);
    setPositionData({});
  }, []);

  const handleDateRange = (selectedDate) => {
    if (selectedDate && selectedDate.startDate && selectedDate.endDate) {
      setDateRange(selectedDate);
    } else {
      setDateRange({ startDate: yesterday, endDate: yesterday });
    }
  };

  function isTodayOrYesterday(dateStr) {
    const date = new Date(dateStr * 1000);
    const today = new Date();
    const yesterday = new Date();

    date.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    yesterday.setDate(today.getDate() - 1);
    yesterday.setHours(0, 0, 0, 0);

    return date.getTime() === today.getTime() || date.getTime() === yesterday.getTime();
  }

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="mb-6">
        <div className="flex justify-between items-center mb-4">
          <h6 className="text-xl font-bold text-gray-800">Ad Partners</h6>
          <SlButton
            variant="primary"
            size="small"
            onClick={() => {
              setShowAdd(true);
              setFlag("add");
              setAdPartnerData({});
            }}
            className="bg-cyan-500 hover:bg-cyan-600 text-white"
          >
            Add
          </SlButton>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {adPartners.length > 0 ? (
            adPartners.map((partner) => (
              <div
                className="border border-gray-200 rounded-lg p-4 bg-white shadow-md relative hover:shadow-lg transition-shadow"
                key={partner.ad_partner_id}
              >
                <div className="flex gap-2 items-center mb-2">
                  <img
                    src={partner.img_url}
                    alt={partner.ad_partner_name}
                    className="h-8 w-8 object-cover rounded-md"
                  />
                  <div>
                    <h6 className="text-lg font-semibold text-gray-800">{partner.ad_partner_name}</h6>
                    {partner.ad_code && (
                      <span className="text-xs text-gray-500">Code: {partner.ad_code}</span>
                    )}
                  </div>
                </div>
                <hr className="my-2" />
                <div className="flex flex-col gap-2 text-sm text-gray-600">
                  <span className="flex gap-1 items-center">
                    <SlIcon library="lucide" name="user" />
                    {partner.user_name || "N/A"}
                  </span>
                  <span
                    className={`flex gap-1 items-center ${
                      isTodayOrYesterday(partner.latest_date)
                        ? "text-green-600"
                        : "text-red-500"
                    }`}
                  >
                    <SlIcon library="lucide" name="calendar" />
                    {partner.latest_date ? formatDateDDMMYYY(partner.latest_date) : "-"}
                  </span>
                </div>
                <div className="flex gap-4 justify-center mt-4">
                  <div
                    className="flex flex-col gap-1 items-center justify-center cursor-pointer"
                    onClick={() => {
                      setFlag("edit");
                      setAdPartnerData(partner);
                      setShowAdd(true);
                    }}
                  >
                    <SlIcon
                      library="lucide"
                      className="text-gray-600 hover:text-cyan-500"
                      name="edit"
                    />
                    <span className="text-xs text-gray-500">Edit</span>
                  </div>
                  <div
                    className={`flex flex-col gap-1 items-center justify-center cursor-pointer ${
                      partner.status === 1
                        ? "text-green-500 hover:text-red-500"
                        : "text-red-500 hover:text-green-500"
                    }`}
                    onClick={() => {
                      setSelectedStatus({ id: partner.ad_partner_id, status: partner.status });
                      setShowModal(true);
                    }}
                  >
                    <SlTooltip
                      content={partner.status === 1 ? "Deactivate" : "Activate"}
                    >
                      <SlIcon
                        library="lucide"
                        className="font-semibold"
                        name="power"
                      />
                      <span className="text-xs text-gray-500">
                        {partner.status === 1 ? "Active" : "Inactive"}
                      </span>
                    </SlTooltip>
                  </div>
                  <div
                    className="flex flex-col gap-1 items-center justify-center cursor-pointer"
                    onClick={() => {
                      setShowStats(true);
                      setAdPartnerData({
                        ad_partner_id: partner.ad_partner_id,
                        ad_partner_name: partner.ad_partner_name,
                        id: partner.id,
                        ad_code: partner.ad_code || null,
                      });
                      setEditStatsData({});
                    }}
                  >
                    <SlIcon
                      library="lucide"
                      className="text-green-600 hover:text-green-700"
                      name="plus-square"
                    />
                    <span className="text-xs text-gray-500">Add Stats</span>
                  </div>
                </div>
                <span
                  className={`absolute right-2 top-2 rounded-md px-2 py-1 text-white text-xs ${
                    partner.status === 1 ? "bg-green-500" : "bg-gray-500"
                  }`}
                >
                  {partner.status === 1 ? "Active" : "Inactive"}
                </span>
              </div>
            ))
          ) : isLoading ? (
            <div className="flex justify-center items-center w-full">
              <svg className="w-6 h-6 animate-spin text-cyan-500" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                />
              </svg>
            </div>
          ) : (
            <div className="text-center text-gray-500 col-span-full">No Ad Partners Found</div>
          )}
        </div>
      </div>
      <div className="space-y-4">
        <div className="flex bg-gray-200 rounded-lg p-1 w-max">
          {["network", "exchange"].map((mode) => (
            <button
              key={mode}
              className={`px-4 py-1 text-sm rounded-md transition-all ${
                viewMode === mode
                  ? "bg-white text-blue-600 shadow-sm"
                  : "text-gray-600 hover:text-gray-800"
              }`}
              onClick={() => setViewMode(mode)}
            >
              {mode === "network" ? "Network Stats" : "Exchange Rates"}
            </button>
          ))}
        </div>
        {viewMode === "network" ? (
          <NetworkStatsTable 
            dateRange={dateRange}
            lang_id={lang_id}
            setShowStats={setShowStats}
            setAdPartnerData={setAdPartnerData}
            setEditStatsData={setEditStatsData}
            loadData={loadData} 
          />
        ) : (
          <ExchangeRates />
        )}
      </div>
      {showAdd && (
        <SlDrawer
          open={showAdd}
          onSlRequestClose={handleRequestClose}
          onSlAfterHide={() => {
            setShowAdd(false);
            setAdPartnerData({});
          }}
        >
          <AddAdPartner
            setShow={setShowAdd}
            flag={flag}
            loadData={loadAdPartners}
            editdata={adPartnerData}
          />
        </SlDrawer>
      )}
      {showStats && (
        <SlDrawer
          open={showStats}
          label={adPartnerData?.ad_partner_name || "Ad Stats"}
          onSlRequestClose={handleRequestClose}
          onSlAfterHide={() => {
            setShowStats(false);
            setEditStatsData({});
            setAdPartnerData(null);
          }}
        >
          <NetworkAdStats
            adPartnerData={adPartnerData}
            setShow={setShowStats}
            loadAdData={loadAdPartners}
            loadData={loadData}
            loadPositionData={loadPositionData}
            loadStats={loadData}
            statsData={editStatsData}
            setStats={setEditStatsData}
          />
        </SlDrawer>
      )}
      <Modal centered show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Status Change</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to{" "}
          {selectedStatus.status === 1 ? "deactivate" : "activate"} this ad partner?
        </Modal.Body>
        <Modal.Footer>
          <SlButton variant="danger" onClick={() => setShowModal(false)}>
            Cancel
          </SlButton>
          <SlButton variant="primary" onClick={handleStatus}>
            Confirm
          </SlButton>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default AdPartners;